import React, { FunctionComponent, useState } from 'react'
import { Card, List, Switch } from 'antd'
import { useEnvironment } from '@strac/react-client-environment'
import { createWeatherLayer } from './utils'
import { useMap } from '@vis.gl/react-google-maps'

const { Item } = List
const { Meta } = Item

interface Option {
  key: string
  name: string
  value: string
}

const options: Option[] = [
  {
    key: 'clouds_new',
    name: 'Clouds',
    value: 'clouds_new'
  },
  {
    key: 'precipitation_new',
    name: 'Precipitation',
    value: 'precipitation_new'
  },
  {
    key: 'pressure_new',
    name: 'Sea Level Pressure',
    value: 'pressure_new'
  },
  {
    key: 'wind_new',
    name: 'Wind Speed',
    value: 'wind_new'
  },
  {
    key: 'temp_new',
    name: 'Temperature',
    value: 'temp_new'
  }
]

const WeatherLayers: FunctionComponent<any> = () => {
  const map = useMap()

  const { REACT_APP_OPEN_WEATHER_API_KEY } = useEnvironment()

  const [weatherLayers, setWeatherLayers] = useState<Map<string, google.maps.ImageMapType>>(new Map())

  const handleChange = (value: boolean, key: string) => {
    if (!map) return

    if (weatherLayers.has(key) && !value) { // Remove
      const layer: any = weatherLayers.get(key)
      if (layer) {
        // Google Map
        const previousLayers = map.overlayMapTypes.getArray()
        const index = previousLayers.indexOf(layer)
        map.overlayMapTypes.removeAt(index)
        // Remove from local state
        setWeatherLayers((prev: Map<string, any>) => {
          prev.delete(key)
          return new Map(prev)
        })
      }
    } else { // Add
      const newLayer: any = createWeatherLayer(map, key, REACT_APP_OPEN_WEATHER_API_KEY || '')
      // Add Layer to map
      map.overlayMapTypes.push(newLayer)
      setWeatherLayers((prev: Map<string, any>) => {
        prev.set(key, newLayer)
        return new Map(prev)
      })
    }
  }

  return (
    <Card>
      <List size={'small'}>
        {options.map((option: Option) => (
          <Item
            key={option.key}
            extra={[
              <Switch
                key={`weather-settings-${option.key}`}
                checked={weatherLayers.has(option.value)}
                onChange={(e) => handleChange(e, option.value)}
              />
            ]}
          >
            <Meta title={option.name} />
          </Item>
        ))}
      </List>
    </Card>
  )
}

export default WeatherLayers
